import Config from '@/services/Config';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.prototype.$config = Config;
});